import {AppError, ErrorType} from "../../domain/model/app_error";
import {backEndConfig} from "../../config/config";

const errorCode: string = backEndConfig.errorCodeForBackEnd;

export function handleError(response: Response): Response {

    if (response.status === 400) {
        throw new AppError(errorCode, ErrorType.API_REQUEST_400,"");
    }

    if (response.status === 401) {
        throw new AppError(errorCode, ErrorType.API_REQUEST_401, "");
    }

    if (response.status === 403) {
        throw new AppError(errorCode, ErrorType.API_REQUEST_403, "");
    }

    if (response.status === 404) {
        throw new AppError(errorCode, ErrorType.API_REQUEST_404, "");
    }

    if (response.status === 409) {
        throw new AppError(errorCode, ErrorType.API_REQUEST_409, "");
    }

    if (response.status === 500) {
        throw new AppError(errorCode, ErrorType.API_REQUEST_500, "");
    }

    if (response.status === 503) {
        throw new AppError(errorCode, ErrorType.API_REQUEST_503, "");
    }

    return response;
}

export function handleFetchError(error: Error):void {
    throw new AppError(Error.name, ErrorType.CLIENT_FETCH_ERROR, `${error.name}: ${error.message}`);
}



// WEBPACK FOOTER //
// ./src/infra/api/error_handler_response.ts